
import React, { Component } from 'react';

export class W extends Component {

    render() {
        return (
            <div>
                <h1 align='center'>Wartburg</h1>
                <br />
                <p>This is a multi youtube channel site that makes videos on tech, entertainment and music, there are 5 channels so far (2 tech, 3 music, 1 entertainment), all ranging in views from 0.5k to 4k views,</p>
                <h2 align="center">Links</h2>
                <ul>
                    <li><b>Kibutsiju </b><a href='https://www.youtube.com/@gdsimpson'>https://www.youtube.com/@gdsimpson</a></li>
                    <li><b>Tanjeet Tech </b><a href='https://www.youtube.com/@tanjeettech2030'>https://www.youtube.com/@tanjeettech2030</a></li>
                    <li><b>BSW_9391 </b><a href='https://www.youtube.com/@bsw_9391'>https://www.youtube.com/@bsw_9391</a></li>
                    <li><b>inspector 2004 </b><a href='https://www.youtube.com/@Inspector20081'>https://www.youtube.com/@Inspector20081</a></li>
                    <li><b>Acf neitzen </b><a href='https://www.youtube.com/@OFFICER-ACF'>https://www.youtube.com/@OFFICER-ACF</a></li>
              
                </ul>
            </div>
        );
    }
}

